import React from 'react';
import Pages from '../app/pages/Pages';
import FooterVersions from './FooterVersions';

// Social-platform glyphs are rendered inline so the footer carries no external
// icon-font dependency (the app only bundles the FontAwesome *solid* set, which
// has no brand marks). Each glyph fills with `currentColor`.
const GLYPHS = {
  facebook: (
    <svg viewBox="0 0 320 512" aria-hidden="true" focusable="false">
      <path d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z" />
    </svg>
  ),
  instagram: (
    <svg viewBox="0 0 448 512" aria-hidden="true" focusable="false">
      <path d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z" />
    </svg>
  ),
  twitter: (
    <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
      <path d="M389.2 48h70.6L305.6 224.2 487 464H345L233.7 318.6 106.5 464H35.8l164.9-188.5L26 48h145.6l100.5 132.9L389.2 48zm-24.8 373.8h39.1L151.1 88h-42l255.3 333.8z" />
    </svg>
  ),
  linkedin: (
    <svg viewBox="0 0 448 512" aria-hidden="true" focusable="false">
      <path d="M100.28 448H7.4V148.9h92.88zM53.79 108.1C24.09 108.1 0 83.5 0 53.8a53.79 53.79 0 0 1 107.58 0c0 29.7-24.1 54.3-53.79 54.3zM447.9 448h-92.68V302.4c0-34.7-.7-79.2-48.29-79.2-48.29 0-55.69 37.7-55.69 76.7V448h-92.78V148.9h89.08v40.8h1.3c12.4-23.5 42.69-48.3 87.88-48.3 94 0 111.28 61.9 111.28 142.3V448z" />
    </svg>
  ),
  youtube: (
    <svg viewBox="0 0 576 512" aria-hidden="true" focusable="false">
      <path d="M549.655 124.083c-6.281-23.65-24.787-42.276-48.284-48.597C458.781 64 288 64 288 64S117.22 64 74.629 75.486c-23.497 6.322-42.003 24.947-48.284 48.597-11.412 42.867-11.412 132.305-11.412 132.305s0 89.438 11.412 132.305c6.281 23.65 24.787 41.5 48.284 47.821C117.22 448 288 448 288 448s170.78 0 213.371-11.486c23.497-6.321 42.003-24.171 48.284-47.821 11.412-42.867 11.412-132.305 11.412-132.305s0-89.438-11.412-132.305zm-317.51 213.508V175.185l142.739 81.205-142.739 81.201z" />
    </svg>
  ),
  email: (
    <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
      <path d="M48 64C21.5 64 0 85.5 0 112c0 15.1 7.1 29.3 19.2 38.4L236.8 313.6c11.4 8.5 27 8.5 38.4 0L492.8 150.4c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48H48zM0 176V384c0 35.3 28.7 64 64 64H448c35.3 0 64-28.7 64-64V176L294.4 339.2c-22.8 17.1-54 17.1-76.8 0L0 176z" />
    </svg>
  ),
  phone: (
    <svg viewBox="0 0 512 512" aria-hidden="true" focusable="false">
      <path d="M164.9 24.6c-7.7-18.6-28-28.5-47.4-23.2l-88 24C12.1 30.2 0 46 0 64C0 311.4 200.6 512 448 512c18 0 33.8-12.1 38.6-29.5l24-88c5.3-19.4-4.6-39.7-23.2-47.4l-96-40c-16.3-6.8-35.2-2.1-46.3 11.6L304.7 368C234.3 334.7 177.3 277.7 144 207.3L193.3 167c13.7-11.2 18.4-30 11.6-46.3l-40-96z" />
    </svg>
  ),
};

// The "Follow us online" social bar — same destinations as the main Utah
// Insurance Department site footer.
const SOCIAL_LINKS = [
  { title: 'Facebook', href: 'https://facebook.com', icon: 'facebook', external: true },
  { title: 'Instagram', href: 'https://instagram.com', icon: 'instagram', external: true },
  { title: 'Twitter', href: 'https://twitter.com/uidnews', icon: 'twitter', external: true },
  { title: 'LinkedIn', href: 'https://linkedin.com', icon: 'linkedin', external: true },
  {
    title: 'YouTube',
    href: 'https://www.youtube.com/channel/UCoXUkNqwomqNWy6r_O8lZvA',
    icon: 'youtube',
    external: true,
  },
  { title: 'Email', href: 'https://insurance.utah.gov/about-us/contact-us/', icon: 'email', external: true },
  { title: 'Phone Number', href: 'tel:18019579200', icon: 'phone', external: false },
];

// The footer navigation column lists this application's own pages (replacing the
// Utah Insurance Department site navigation). Each link is a SPA navigation
// (Page.forward pushes onto history); the href keeps it a real, focusable link.
const FOOTER_NAV = [
  { label: 'Home', page: Pages.home },
  { label: 'Drug Listings', page: Pages.listings },
  { label: 'WAC History', page: Pages.wacs },
  { label: 'Approval History', page: Pages.approvals },
  { label: 'Patent History', page: Pages.patents },
  { label: 'Users', page: Pages.users },
  { label: 'Companies', page: Pages.companies },
  { label: 'Report', page: Pages.report },
];

// The "Online Services" column — same destinations as the main Utah Insurance
// Department site footer.
const ONLINE_SERVICES = [
  { label: 'Licensee Search', href: 'https://insurance.utah.gov/licensee-search/' },
  { label: 'Online Payments', href: 'https://payment.uid.utah.gov/s/' },
  { label: 'Forms and Publications', href: 'https://insurance.utah.gov/forms-reports/' },
  {
    label: 'Administrative Actions',
    href: 'https://insurance.utah.gov/consumers/legal-resources/enforcement/',
  },
  { label: 'File Upload', href: 'https://portal.uid.utah.gov/' },
];

const Footer = () => (
  <footer className="app-footer" role="contentinfo">
    <div className="app-footer__social-bar">
      <div className="app-footer__container app-footer__social">
        <p className="app-footer__social-heading">Follow us online</p>
        {SOCIAL_LINKS.map((link) => (
          <a
            key={link.title}
            className="app-footer__social-link"
            href={link.href}
            title={link.title}
            aria-label={link.title}
            {...(link.external
              ? { target: '_blank', rel: 'noopener noreferrer' }
              : {})}
          >
            {GLYPHS[link.icon]}
          </a>
        ))}
      </div>
    </div>

    <div className="app-footer__main-bar">
      <div className="app-footer__container app-footer__columns">
        <div className="app-footer__col app-footer__logo-col">
          <a href="https://insurance.utah.gov/">
            <img
              src="https://insurance.utah.gov/wp-content/uploads/UIDfooterlogo.png"
              width="326"
              height="108"
              alt="Utah Insurance Department logo; links to insurance.utah.gov"
              loading="lazy"
            />
          </a>
        </div>

        <div className="app-footer__col app-footer__address-col">
          <div>4315 S. 2700 W.</div>
          <div>Suite 2300</div>
          <div>Taylorsville, UT 84129</div>
          <div className="app-footer__address-contact">
            <div>Phone: (801) 957-9200</div>
            <div>Toll-free: (800) 439-3805</div>
          </div>
          <a href="https://insurance.utah.gov/about-us/contact-us/">Contact us</a>
        </div>

        <div className="app-footer__col app-footer__nav-col">
          <div className="app-footer__col-heading">Navigation Menu</div>
          <ul>
            {FOOTER_NAV.map((item) => (
              <li key={item.label}>
                <a href={item.page.path} onClick={item.page.forward}>
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="app-footer__col app-footer__services-col">
          <div className="app-footer__col-heading">Online Services</div>
          <ul>
            {ONLINE_SERVICES.map((service) => (
              <li key={service.label}>
                <a href={service.href} target="_blank" rel="noopener noreferrer">
                  {service.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
      <FooterVersions />
    </div>
  </footer>
);

export default Footer;
